export default __webpack_public_path__ + "f4703173fc68270f12c69469eac7e0e6.svg";